export default __webpack_public_path__ + "static/media/collect-translate-1.6d6c902b.webp";